export const fonts = {
  heading: `'Roboto', sans-serif`,
  body: `'Inter', sans-serif`,
};
